import { render, staticRenderFns } from "./couponGiveConfig.vue?vue&type=template&id=340c0747&"
import script from "./couponGiveConfig.vue?vue&type=script&lang=js&"
export * from "./couponGiveConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports